<template>
  <svg :width="width"
       :height="height"
       role="presentation"
       viewBox="0 0 16 16"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor" fill-rule="nonzero">
      <path d="M2 3.624l4.91-.67v4.637H2zM2 8.273h4.91v4.772L2 12.365zM7.455 2.889L14 2v5.59H7.455zM7.455 13.098V8.273H14V14z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>